import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import GradingCategoryForm from '../../../components/forms/GradingCategoryForm';
import { useGradingCategoryApi } from '../../../hooks/useGradingCategoryApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { GradingCategoryDTO } from '../../../services/apiClient';

const GradingCategoryEdit: React.FC = () => {
  const { getById, edit, isLoading } = useGradingCategoryApi();
  const [entityData, setEntityData] = useState<GradingCategoryDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Grading Categories', href: '/admin/gradingcategories' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Grading Category data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/gradingcategories');
    } catch (error) {
      console.error('Error updating Grading Category:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/gradingcategories"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.GradingCategory.Edit'
    >
        {entityData ? (
          <GradingCategoryForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/gradingcategories')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default GradingCategoryEdit;